import React from "react"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import { renderPlatformIcon } from "aldoo-ra/Admin/utils/platformIconUtils"

/**
 * Unified Platform Selector Component
 * 
 * A reusable dropdown component for selecting platforms with consistent styling,
 * platform icons, and proper "Any Platform" handling across the application.
 */
const PlatformSelector = ({
  // Platform-specific props
  platforms = [
    { value: "any", label: "All Platforms" },
    { value: "ios", label: "iOS" },
    { value: "android", label: "Android" },
    { value: "windows", label: "Windows" },
    { value: "linux", label: "Linux" },
    { value: "macos", label: "macOS" },
    { value: "web", label: "Web" },
  ],
  value,
  onChange,
  placeholder = "Select platforms...",
  label,
  
  // DropdownSelect props (passed through)
  variant = "admin",
  searchEnabled = true,
  multiSelection = true,
  showCheckbox = false,
  showSelectionTick = true,
  showSelectAll = false, // Disabled by default for platforms since "Any Platform" serves this purpose
  fixedWidth,
  className,
  disabled = false,
  error,
  required = false,
  zIndex,
  
  // Custom styling
  styleOverrides,
  
  // Additional props
  ...otherProps
}) => {
  // Custom item renderer with platform icons
  const renderPlatformItem = (option) => (
    <div className="flex items-center gap-2">
      {renderPlatformIcon(option.value, "w-4 h-4 text-admin_text_secondary")}
      <span>{option.label}</span>
    </div>
  )

  // Custom value renderer for selected items display
  const renderSelectedValue = (option) => {
    if (!option) return "No platforms"
    return option.label || option.value || "Unknown platform"
  }

  return (
    <DropdownSelect
      variant={variant}
      searchEnabled={searchEnabled}
      multiSelection={multiSelection}
      showCheckbox={showCheckbox}
      showSelectionTick={showSelectionTick}
      showSelectAll={showSelectAll}
      allowEmptySelection={false}
      label={label}
      placeholder={placeholder}
      options={platforms}
      value={value}
      onChange={onChange}
      fixedWidth={fixedWidth}
      className={className}
      disabled={disabled}
      error={error}
      required={required}
      zIndex={zIndex}
      styleOverrides={styleOverrides}
      onItemRender={renderPlatformItem}
      onValueItemRender={renderSelectedValue}
      {...otherProps}
    />
  )
}

export default PlatformSelector